var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"main-wrapper",staticStyle:{"padding-top":"1.75rem"},attrs:{"fluid":""}},[_c('b-container',[_vm._v("Tes")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }